import type { MenuLocales } from '@/types/lang/locales'
import { menuEn as libMenuEn } from '@rfc/rfc-components-library/locales'

export const menuEn: MenuLocales = {
    ...libMenuEn,
    checkpoints: 'Checkpoints',
    events: 'Events',

    adminHubMenu: 'uRTime administration',
    stats: 'Statistics'
}
